const NotFound = () => {
  return (
    <div>
      <h1>NotFound</h1>
      <p>페이지를 찾지 못했습니다.</p>
    </div>
  );
};

export default NotFound;
